import { useState } from "react"
import { Link } from "react-router-dom"

import useFlashMessage from '../../../hooks/useFlashMessage'

//functions
import NumberToMoney from '../../../shared/functions/NumberToMoney'
/* form */
import Input from "../../../shared/components/form/input"
import FormLayout from "../../../shared/components/FormLayout/FormLayout"
import FormSection from "../../../shared/components/FormLayout/FormSection"
import Button from "../../../shared/components/Button/Button"

function FormSize({ handleSubmit, sizeData, btnText, btCancelLink, btCancelAction, title }) {

    const { setFlashMessage } = useFlashMessage()

    const [size, setSize] = useState(sizeData || {})

    function handleChange(e) {
        setSize({ ...size, [e.target.name]: e.target.value })
    }

    /* ----------------- function  money 0.00 ------------------- */
    function handleChangeMoney(e) {
        let value = NumberToMoney(e.target.value)
        setSize({ ...size, [e.target.name]: value })
    }

    const submit = (e) => {
        e.preventDefault()

        if (!size.name) {
            setFlashMessage("O nome do tamanho é obrigatório", 'error')
            return
        }
        if (!size.price) {
            setFlashMessage("O valor do aditivo de tamanho é obrigatório", 'error')
            return
        }

        handleSubmit(size)
    }

    return (
        <FormLayout
            title={title}
            onSubmit={submit}
            actions={
                <>
                    <Button variant="save" type="submit">{btnText || 'Salvar'}</Button>
                    {btCancelLink
                        ? <Link className="link-default" to={btCancelLink}><Button variant="cancel">Cancelar</Button></Link>
                        : btCancelAction && <Button variant="cancel" onClick={btCancelAction}>Cancelar</Button>
                    }
                </>
            }
        >
            <FormSection>
                <div className="fl-row">
                    <div className="fl-col-mid form-group">
                        <Input
                            text="Tamanho"
                            type="text"
                            name="name"
                            placeholder="digite o nome do tamanho"
                            handleOnChange={handleChange}
                            value={size.name || ''}
                        />
                    </div>
                    <div className="fl-col-mid form-group">
                        <Input
                            text="Valor adicional"
                            type="text"
                            name="price"
                            placeholder=""
                            handleOnChange={handleChange}
                            handleOnBlur={handleChangeMoney}
                            value={size.price || ''}
                        />
                    </div>
                </div>
            </FormSection>
        </FormLayout>
    )
}

export default FormSize
